/* Home — Say bye bye: cards rise in, the old options get struck through and dim, Hello pops (elastic). */
(function () {
  function Bye(sec) {
    var D = window.Dozzee || {}, ctx = null, alive = true;
    var q = function (s) { return Array.prototype.slice.call(sec.querySelectorAll(s)); };
    if (D.reduce) {
      q('[data-strike]').forEach(function (s) { s.style.transform = 'none'; });
    } else if (D.gsap) D.gsap(function (gsap) {
      if (!alive) return;
      ctx = gsap.context(function () {
        var strikes = q('[data-strike]'), byes = q('[data-bye-card]'), hello = sec.querySelector('[data-hello]');
        gsap.set(strikes, { scaleX: 0 });
        gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top 60%', once: true } })
          .from(byes.concat(hello ? [hello] : []), { y: 50, opacity: 0, duration: 0.9, stagger: 0.12, ease: 'expo.out' }, 0)
          .to(strikes[0], { scaleX: 1, duration: 0.45, ease: 'power2.inOut' }, 0.7).to(byes[0], { opacity: 0.55, duration: 0.4 }, 0.95)
          .to(strikes[1], { scaleX: 1, duration: 0.45, ease: 'power2.inOut' }, 1.05).to(byes[1], { opacity: 0.55, duration: 0.4 }, 1.3)
          .fromTo(hello, { scale: 0.95, rotation: -2 }, { scale: 1.03, rotation: 0, duration: 0.35, ease: 'power2.out' }, 1.35)
          .to(hello, { scale: 1, duration: 0.6, ease: 'elastic.out(1,0.5)' }, 1.7);
      }, sec);
    });
    this.destroy = function () { alive = false; if (ctx) ctx.revert(); };
  }
  function init(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-section-type="home-bye"]')).forEach(function (sec) {
      if (!sec._hmBye) sec._hmBye = new Bye(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll('[data-section-type="home-bye"]')).forEach(function (sec) {
      if (sec._hmBye) { sec._hmBye.destroy(); sec._hmBye = null; }
    });
  });
})();
